import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontSize: 18
  },
});

export default theme;
